/** Keep EXTENSUS filling the visible screen: rotation, notch, iOS keyboard, native WebView. */

export function applyVisibleViewport(root: CSSStyleDeclaration = document.documentElement.style) {
  const vv = window.visualViewport;
  const height = vv?.height || window.innerHeight || 0;
  const top = vv?.offsetTop || 0;
  root.setProperty('--app-vh', `${Math.round(height)}px`);
  root.setProperty('--vv-top', `${Math.round(top)}px`);
}

export function startViewportAdapter() {
  applyVisibleViewport();
  const onChange = () => applyVisibleViewport();
  window.visualViewport?.addEventListener('resize', onChange);
  window.visualViewport?.addEventListener('scroll', onChange);
  window.addEventListener('orientationchange', onChange);
  window.addEventListener('resize', onChange);
  return () => {
    window.visualViewport?.removeEventListener('resize', onChange);
    window.visualViewport?.removeEventListener('scroll', onChange);
    window.removeEventListener('orientationchange', onChange);
    window.removeEventListener('resize', onChange);
  };
}
